import { HistorialComponent } from './../components/historial.component';
import { HomeComponent } from './../components/home.component';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { MaterialModules } from './material.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routing } from './../routing/app.routing';
import { AppComponent } from './../components/app.component';
import { MenuComponent } from './../components/menu.component';
import { ListaPacientesComponent } from '../components/listapacientes.component';
import { LoginComponent } from './../components/login.component';
import { FormularioPaciente } from '../components/crearpaciente.component';

//formularios y two way data binding
import { FormsModule } from '@angular/forms';
//modulo para consumir api rest
import { HttpClientModule } from '@angular/common/http';
import { EditPacientesComponent } from '../components/editor.component';
import { FilterPipe } from '../pipes/search.pipe';




@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    ListaPacientesComponent,
    LoginComponent,
    FormularioPaciente,
    HomeComponent,
    HistorialComponent,
    EditPacientesComponent,
    FilterPipe


  ],
  imports: [
    BrowserModule,
    MaterialModules,
    NgbModule,
    FormsModule,
    Routing,
    HttpClientModule

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/